<template>
  <v-sheet>
    <h4 class="form-title">회원가입</h4>
    <p class="form-subtitle">
      이안드라이브 콘솔에 가입을 해주세요
    </p>
    <template
      v-if="useFirebase">
      <v-btn
        color="primary"
        block
        large
        @click="signInWithGoogle">
        <v-icon left>mdi-google</v-icon>
        Google 계정으로 회원가입
      </v-btn>
      <div class="text-center py-4">
        또는
      </div>
    </template>
    <v-form
      ref="form"
      v-model="valid"
      lazy-validation
      @keyup.native.enter="signInWithEmailAndPassword">
      <label class="form-label">이메일</label>
      <v-text-field
        v-model="form.email"
        :rules="[
          rule.required,
          rule.minLength(5),
          rule.maxLength(50),
          rule.email
        ]"
        dense
        flat
        solo
        outlined
        placeholder="이메일을 입력해주세요">
      </v-text-field>
      <label class="form-label">비밀번호</label>
      <v-text-field
        type="password"
        v-model="form.passwd"
        :rules="[
          rule.required,
          rule.minLength(5),
          rule.maxLength(50)
        ]"
        dense
        flat
        solo
        outlined
        placeholder="비밀번호를 입력해주세요">
      </v-text-field>
      <label class="form-label">이름</label>
      <v-text-field
        v-model="form.last_name"
        dense
        flat
        solo
        outlined
        placeholder="성"
        :rules="[
          rule.required,
          rule.minLength(1),
          rule.maxLength(20)
        ]">
      </v-text-field>
      <v-text-field
        v-model="form.first_name"
        dense
        flat
        solo
        outlined
        placeholder="이름"
        :rules="[
          rule.required,
          rule.minLength(1),
          rule.maxLength(20)
        ]">
      </v-text-field>
      <v-checkbox
        label="약관에 동의함"
        v-model="agree"
        :rules="[rule.agree]"
        required
        hide-details
        class="mt-0 mb-4">
      </v-checkbox>
      <v-btn
        color="primary"
        depressed
        block
        large
        @click="createWithEmailAndPassword">
        회원가입
      </v-btn>
      <v-divider class="py-4"></v-divider>
      <v-btn
        color="primary"
        depressed
        outlined
        block
        large
        @click="$emit('changeType')">
        로그인
      </v-btn>
    </v-form>
  </v-sheet>
</template>
<script>
import CONFIG from '@/config'
import { AuthAPI } from '@/api'

export default {
  data: () => ({
    form: {
      first_name: '',
      last_name: '',
      email: '',
      passwd: ''
    },
    agree: false,
    valid: false,
    rule: {
      required: (v) => !!v || '필수 항목입니다.',
      minLength: (length) => (v) =>
        v.length >= length || `${length}자리 이상으로 입력하세요.`,
      maxLength: (length) => (v) =>
        v.length <= length || `${length}자리 이하으로 입력하세요.`,
      email: (v) => /.+@.+/.test(v) || '이메일 형식에 맞지 않습니다.',
      agree: (v) => !!v || '약관에 동의해야 진행됩니다.'
    }
  }),

  computed: {
    useFirebase () {
      return CONFIG.USE_FIREBASE
    }
  },

  methods: {
    async signInWithGoogle () {
      const provider = new this.$firebase.auth.GoogleAuthProvider()
      this.$firebase.auth().languageCode = 'ko'
      await this.$firebase.auth().signInWithPopup(provider)
      await this.$firebase.auth().signOut()
      this.$emit("changeType")
    },
    async createWithEmailAndPassword () {
      if (!this.$refs.form.validate()) {
        this.$toasted.global.error('입력 폼을 올바르게 작성해주세요.');
        return false
      }

      if (CONFIG.USE_FIREBASE) {
        await this.$firebase
          .auth()
          .createUserWithEmailAndPassword(this.form.email, this.form.passwd);
        const user = this.$firebase.auth().currentUser;
        await user.updateProfile({
          displayName: `${this.form.last_name} ${this.form.firstName}`,
        });
        await this.$firebase.auth().signOut();
      } else {
        await AuthAPI.registUser(this.form);
      }
      // goto login...
      this.$emit('changeType');
    },
  },
  created: () => {},
};
</script>
<style scoped>
.recaptcha-terms-text {
  font-size: 12px;
  font-weight: 200;
  color: #637282;
}

.form-title {
  font-size: 1.5rem;
  font-weight: 600;
  text-align: center;
  margin-bottom: 0.875rem;
}

.form-subtitle {
  font-size: .9rem;
  color: rgba(0, 0, 0, 0.6);
  text-align: center;
  margin-bottom: 2.25rem;
}
</style>



// WEBPACK FOOTER //
// src/components/auth/signUp.vue